import React, { useState, useEffect  } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom'
import * as UserActions from '../../../actions/UserActions'
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import { loginWithToken } from '../../../utils/Helper'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { API_URL } from '../../../utils/Settings'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
} from 'reactstrap';
import NaranciaSubHeader from '../parts/NaranciaSubHeader'
import UploadAudioDiv from '../parts/UploadAudioDiv'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

// NaranciaUpload
const NaranciaUpload = (props) => {

  // use history
  let navigate = useNavigate()

  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });

  let user_info = useSelector(state => {
    if (state.user && state.user.user_info) {
      return state.user.user_info
    } else {
      return ''
    }
  });

  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  });

  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let dispatch = useDispatch();

  // parameters
  let [loading, setLoading] = useState(false);
  let [selectedFile, setSelectedFile] = useState(null);
  // let [masterList, setMasterList] = useState([])
  // let [kiyakuCheck, setKiyakuCheck] = useState(false)
  let [category1, setCategory1] = useState("")
  let [category2, setCategory2] = useState("")
  let [memo, setMemo]  = useState("")

  // componentDidMount
  useEffect(() => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return;
    }

    // first script
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // file selected
  let _fileSlected = async (acceptedFiles) => {

    if (acceptedFiles.length !== 1) {

      Alert.info("音声ファイルは一つずつアップロードして頂けますでしょうか。", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      return
    }

    let _selectedFile = acceptedFiles[0]
    setSelectedFile(_selectedFile)
  }

  // _firstScript
  let _firstScript = () => {
    // _getEvaluationList()
    console.log("_firstScript.1")
  }

  // upload test audio
  let _uploadAudio = async () => {

    // return

    try {

      if (!selectedFile) {
        throw Error("file not selected")
      }

      setLoading(true)

      // send data
      let fd = new FormData();
      fd.append('login_token', login_token)
      fd.append('category1', category1)
      fd.append('category2', category2)
      fd.append('memo', memo)
      fd.append('upl', selectedFile, selectedFile.name);
      let results_1 = await MyAPI.naranciaUploadAudio(fd)
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      Alert.success("OK", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get evaluation master failes
      // _getEvaluationList()

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }


  let _handleChangeCategory1 = (e) => {
    setCategory1(e.target.value)
  }
  let _handleChangeCategory2 = (e) => {
    setCategory2(e.target.value)
  }
  let _handleMemoChange = (e) => {
    setMemo(e.target.value)
  }


  return (
    <div style={{
      backgroundColor: '#ffffff',
    }}>

      {/* header */}
      <Header />

      {/* sub header */}
      <NaranciaSubHeader />

      <Container>

        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="3" xs="12" />

          <Col md="6" xs="12">
            <UploadAudioDiv fileSlected={_fileSlected} />
          </Col>

          <Col md="3" xs="12" />
        </Row>

        {/* upload button */}
        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="3" xs="12" />

          <Col md="3" xs="12">
            <Input
              onChange={_handleChangeCategory1}
              type="select"
              name="category1"
              value={category1}>
              <option value="">-</option>
              <option value="call">電話</option>
              <option value="baseball">野球</option>
              <option value="geekfeed">ギークフィード</option>
              <option value="miscellaneous">その他</option>
            </Input>
          </Col>

          <Col md="3" xs="12">

            {category1 === "call" && (
              <Input
                onChange={_handleChangeCategory2}
                type="select"
                name="category2"
                value={category2}>
                <option value="">-</option>
                <option value="cheer_mom">ちあまざ</option>
              </Input>
            )}
            {category1 === "baseball" && (
              <Input
                onChange={_handleChangeCategory2}
                type="select"
                name="category2"
                value={category2}>
                <option value="">-</option>
                <option value="hisaki">@HISAKI/毎日やきう速報</option>
                <option value="satozaki">里崎チャンネル</option>
              </Input>
            )}
            {category1 === "geekfeed" && (
              <Input
                onChange={_handleChangeCategory2}
                type="select"
                name="category2"
                value={category2}>
                <option value="">-</option>
                <option value="collabos">コラボス</option>

              </Input>
            )}
            {category1 === "miscellaneous" && (
              <Input
                onChange={_handleChangeCategory2}
                type="select"
                name="category2"
                value={category2}>
                <option value="">-</option>
                <option value="ohashi">大橋デモ用</option>
                <option value="kihara">木原さん</option>

              </Input>
            )}
          </Col>

          <Col md="3" xs="12" />
        </Row>
        <Row style={{
          marginTop: 20,
          marginBottom: 20,
        }}>
          <Col md="3" xs="12" />

          <Col md="6" xs="12">
            <Input
              type="text"
              style={{
                width: '100%',
              }}
              name='memo'
              onChange={_handleMemoChange}
              value={memo}
              placeholder="メモ…" />
          </Col>

          <Col md="3" xs="12" />
        </Row>
        <Row style={{
          marginTop: 20,
          marginBottom: 60,
        }}>
          <Col md="3" xs="12" />

          <Col md="6" xs="12">
            <Button
              onClick={_uploadAudio}
              color="primary"
              style={{
                cursor: 'pointer',
                width: '100%',
              }}>
              upload
            </Button>
          </Col>

          <Col md="3" xs="12" />
        </Row>

      </Container>

      <br/>

      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default NaranciaUpload
